import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useGlobalConfigContext } from '../../global-config'
import { LOCALE } from '../../i18n'
import { StaticImage } from '../../image'

const MAX_IMAGE_SIZE = 580

const imageSrc = {
  [LOCALE.DE_AT]:
    'https://static.shop-apotheke.at/media/newsletter/misc-newsletter-example-at.png',
  [LOCALE.DE_CH]:
    'https://static.redcare-apotheke.ch/media/newsletter/misc-newsletter-example-de-CH.png',
  [LOCALE.DE_DE]:
    'https://static.shop-apotheke.com/media/newsletter/misc-newsletter-example-com.png',
  [LOCALE.FR_BE]:
    'https://static.shop-apotheke.ch/media/temp/sa-be/media/newsletter/misc-newsletter-example-fr-BE.png',
  [LOCALE.FR_CH]:
    'https://static.redcare-apotheke.ch/media/newsletter/misc-newsletter-example-fr-CH.png',
  [LOCALE.FR_FR]:
    'https://static.redcare-pharmacie.fr/media/newsletter/misc-newsletter-example-fr-rebranding.jpg',
  [LOCALE.IT_IT]:
    'https://static.redcare.it/media/newsletter/misc-newsletter-example-it-rebranding.jpg',
  [LOCALE.NL_BE]:
    'https://static.shop-apotheke.ch/media/temp/sa-be/media/newsletter/misc-newsletter-example-nl-BE.png',
}

interface NewsletterExampleModalProps {
  onClose: () => void
  open: boolean
}

export const NewsletterExampleModal: FC<NewsletterExampleModalProps> = ({
  onClose,
  open,
}) => {
  const { locale } = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle
        onClose={onClose}
        slotProps={{
          closeButton: {
            'aria-label': intl.formatMessage({
              id: 'general.link.label.close',
            }),
          },
        }}
      >
        {intl.formatMessage({
          id: 'newsletter.page.example',
        })}
      </DialogTitle>
      <DialogContent>
        <StaticImage
          alt={intl.formatMessage({
            id: 'newsletter.page.example',
          })}
          height={MAX_IMAGE_SIZE}
          src={imageSrc[locale]}
          width={MAX_IMAGE_SIZE}
        />
      </DialogContent>
    </Dialog>
  )
}
